import styles from '../css/styles.css'
import { Map, TileLayer } from 'leaflet'
import '../../node_modules/leaflet/dist/leaflet.css'
import 'font-awesome/css/font-awesome.css'
import $ from "jquery"

const options = {
	scrollWheelZoom: false,
	dragging: false,
}

var mapChurch = new Map('map-church', options)
	.setView([56.16913, 10.21029], 16)
var mapParty = new Map('map-party', options)
	.setView([56.19351, 10.20808], 16)

new TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
	.addTo(mapParty)

new TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
	.addTo(mapChurch)


const stickToTop = function() {
	let menuHeight = $('.menu').height();
	let menuTop = $('.menu').offset().top;

	if ($(window).scrollTop() >= (menuTop + menuHeight)) {
		// scrolled past the original position; now only show the cloned, sticky element.
		$('.to-top').fadeIn();
	} else {
		// not scrolled past the menu; only show the original menu.
		$('.to-top').fadeOut();
	}
}

$(document).ready(function () {
	setInterval(stickToTop, 10);
})



// WEBPACK FOOTER //
// ./src/js/app.js